
webpack.register(
    'modules/the-course/featured-video/featured-video',
    function() {
        return import('modules/the-course/featured-video/featured-video');
    },
    true
);